<template>
  <CardLayout v-bind="clickable ? { onClick: () => $emit('click') } : {}">
    <template #header>
      {{ $t('report.sales_distribution_title') }}
    </template>
    <div v-if="productsReportLoaded"
      class="w-full flex flex-col justify-between items-center">
      <div class="w-full">
        <HHIScoreBadge :hhi-value="hhiIndex" />
      </div>

      <div class="w-full mt-2">
        <SalesFamilyRepartitionBar :series="totalSalesByFamilySeries" />
      </div>
    </div>
    <div v-else>
      <Loading />
    </div>
  </CardLayout>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { ProductsReportResponse } from '../../responses'
import { colorsUtils } from '../../utils/ColorsUtils'
import CardLayout from '../CardLayout.vue'
import Loading from '../Loading.vue'
import HHIScoreBadge from '../HHIScoreBadge.vue'
import SalesFamilyRepartitionBar from '../charts/SalesFamilyRepartitionBar.vue'

const props = withDefaults(defineProps<{
  productsReport: ProductsReportResponse | null | undefined
  clickable?: boolean
}>(), {
  clickable: true,
})

defineEmits<{
  click: []
}>()

const productsReportLoaded = computed(() => {
  return props.productsReport != null
})

const hhiIndex = computed(() => {
  return Math.round(props.productsReport?.performance_analysis.diversity_metrics.revenue_herfindahl_index || 0)
})

const totalSalesByFamilySeries = computed<echarts.BarSeriesOption[] | []>(() => {
  if (!props.productsReport) {
    return []
  }

  const revenue_distribution = props.productsReport.performance_analysis.diversity_metrics.revenue_distribution
  const total = Object.values(revenue_distribution).reduce((acc, val) => acc + val, 0)

  return Object.entries(revenue_distribution).map(([familyName, amount], index) => {
    const percentage = (amount / total) * 100
    return {
      name: familyName,
      type: 'bar',
      data: [percentage],
      stack: 'total',
      color: colorsUtils.getColor(index),
      roundCap: true,
    }
  })
})
</script>
